const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getMnPowerConfig(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/mn-power/config`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      return null;
    }
    throw new Error('Failed to fetch MN Power config');
  }
  
  const data = await response.json();
  return data.config;
}

export async function getMnPowerFields(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/mn-power/fields`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch MN Power fields');
  }
  
  const data = await response.json();
  return data.fields;
}

export async function getMnPowerTemplates(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/mn-power/templates`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch MN Power templates');
  }
  
  const data = await response.json();
  return data.templates;
}

export async function getMnPowerReportProfiles(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/mn-power/report-profiles`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch MN Power report profiles');
  }
  
  const data = await response.json();
  return data.profiles;
}

export async function validateMnPowerField(orgId, field, value) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/mn-power/validate`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ field, value })
  });
  
  if (!response.ok) {
    throw new Error('Failed to validate field');
  }
  
  return response.json();
}
